import { Divider, Theme, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'

export interface TitleProps {
  title: string
  color?: string
  stickyTopOffset?: number
  bleedPx?: number
}

export const Title = (props: TitleProps) => {
  const classes = useStyles(props)
  return (
    <div className={props.stickyTopOffset !== undefined ? classes.stickyWrapper : undefined}>
      <Typography className={classes.title} variant={'h3'} align="left">
        {props.title}
      </Typography>
      <Divider className={classes.divider} />
    </div>
  )
}

const useStyles = makeStyles<Theme, TitleProps>((theme: Theme) => ({
  title: (props) => ({
    color: props.color,
    fontSize: 38,
    paddingBottom: theme.spacing(0),
  }),
  divider: {
    marginBottom: theme.spacing(4),
  },
  stickyWrapper: (props) => ({
    position: 'sticky',
    top: props.stickyTopOffset,
    zIndex: 60,
    backgroundColor: 'white',
    paddingTop: theme.spacing(1),
    marginLeft: props.bleedPx ? -props.bleedPx : 0,
    marginRight: props.bleedPx ? -props.bleedPx : 0,
    width: props.bleedPx ? `calc(100% + ${props.bleedPx * 2}px)` : '100%',
  }),
}))
